import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';



const HEADERS = {};
@Injectable()
export class XmlFormatSettingService {
  static ENV = environment;
  public dataFormat: any[] = [];
  constructor(private httpService: HttpService) { }


  public getPrintColunms(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get('assets/data/print-column.json', httpRequesthandler);
  }
  public getDataType(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get('assets/data/data-types.json', httpRequesthandler);
  }
  public getDataLedger(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(XmlFormatSettingService.ENV.environment.API.get_ledger, httpRequesthandler);
  }
  public getDataFormat(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(XmlFormatSettingService.ENV.environment.API.get_formats, httpRequesthandler);
  }
  public getDataDetailActtribute(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get('assets/data/detail-attribute.json', httpRequesthandler);
  }

  public getDataItemSOAP(data: any, httpRequesthandler: HttpRequestHandler): void {
    //#TODO: Cambiar por el consumo de la funcion 
    httpRequesthandler.headers = HEADERS;
    this.httpService.get('assets/data/items.json', httpRequesthandler);
  }

  public getDataItemMode(data: any, httpRequesthandler: HttpRequestHandler): void {
    //#TODO: Cambiar por el consumo de la funcion 
    httpRequesthandler.headers = HEADERS;
    this.httpService.get('assets/data/data-mode.json', httpRequesthandler);
  }


  public save(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(XmlFormatSettingService.ENV.environment.API.formats, data, httpRequesthandler);
  }

  public consult_formats(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(XmlFormatSettingService.ENV.environment.API.consult_formats, data, httpRequesthandler);
  }

  public xmlFormats(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(XmlFormatSettingService.ENV.environment.API.get_xml_formats, data, httpRequesthandler);
  }

  public addFormat(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(XmlFormatSettingService.ENV.environment.API.create_format, data, httpRequesthandler);
  }

  public saveFormatCols(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(XmlFormatSettingService.ENV.environment.API.formats_cols, data, httpRequesthandler);
  }


  public deleteFormatCols(id: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${XmlFormatSettingService.ENV.environment.API.formats_cols}/${id}`,  httpRequesthandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/xml-format-setting/xml-format-setting.service.ts